/**
 * 追加CSSに関するUtil。
 */
export default class CustomCssUtil {
	/**
	 * 追加CSSを画面内にレンダリング。
	 * @param {string} css 追加CSS内容。
	 */
	public static renderCustomCss(css: string | null): void {
		if (!css) {
			return;
		}

		const styleElement = document.createElement("style");
		styleElement.innerHTML = css;
		const bodyElement = document.querySelector("body");
		bodyElement?.appendChild(styleElement);
	}
}
